(function() {
  const protectionHandle = 'shipping-protection-1';
  let inFlight = false;

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest('[name="checkout"], button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], .shopify-payment-button__button')
    );
  }

  async function getProtectionVariantId() {
    const res = await fetch('/products/' + protectionHandle + '.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load protection product');
    const product = await res.json();
    const variant = (product.variants && product.variants.find(v => v.available)) || (product.variants && product.variants[0]);
    if (!variant) throw new Error('No protection variant found');
    return variant.id;
  }

  async function getCartState() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load cart');
    const cart = await res.json();
    const items = cart.items || [];
    const nonProtection = items.filter(item => item.handle !== protectionHandle);
    const hasProtection = items.length !== nonProtection.length;
    const allGiftCards = nonProtection.length > 0 && nonProtection.every(item => (item.product_type || '').toLowerCase() === 'gift card');
    return { hasProtection: hasProtection, hasNonProtectionItems: nonProtection.length > 0, allGiftCards: allGiftCards };
  }

  async function addProtection(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!res.ok) throw new Error('Failed to add protection');
    return res.json();
  }

  async function ensureProtectionThenCheckout() {
    if (inFlight) return;
    inFlight = true;
    try {
      const state = await getCartState();
      // Skip auto-add when cart contains only gift cards (or already has protection / is empty).
      const shouldAdd = !state.hasProtection && state.hasNonProtectionItems && !state.allGiftCards;
      if (shouldAdd) {
        const variantId = await getProtectionVariantId();
        await addProtection(variantId);
      }
    } catch (err) {
      console.error(err);
    } finally {
      inFlight = false;
      window.location.assign('/checkout');
    }
  }

  document.addEventListener('click', function(event) {
    const trigger = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], .shopify-payment-button__button')
      : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    ensureProtectionThenCheckout();
  }, true);

  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || !(form.matches && form.matches('form'))) return;

    const submitter = event.submitter || document.activeElement;
    if (!isCheckoutTrigger(submitter)) return;

    event.preventDefault();
    event.stopPropagation();
    ensureProtectionThenCheckout();
  }, true);
})();
